import type { I } from '@/types/project';
import { getQueryString } from '@hll/eapp-utils';

const getEnv = (() => {
  let env = 'prod';
  try {
    const { hostname } = window.location;
    if (
      hostname === 'localhost' ||
      /^192\./.test(hostname) ||
      /^172\./.test(hostname) ||
      /(^|[.-])dev([.-]|$)/.test(hostname)
    ) {
      env = 'pre'
    } else if (/(^|[.-])stg([.-]|$)/.test(hostname)) {
      env = 'stg'
    } else if (/(^|[.-])pre([.-]|$)/.test(hostname)) {
      env = 'pre'
    }
  } catch (error) {
    env = 'prod';
  }
  return env;
})();

/**
 * 优先级设定
 * van -> url -> url路径规则
 */

// van注入的全局变量
const vanEnv = document?.documentElement?.dataset?.vanEnv;

// 初始化 - url 规则取环境
let loaclEnv = vanEnv || getEnv;
if (!vanEnv) {
  // 取query部分
  const urlEnv = getQueryString('env');
  // 校验值是不是在范围内
  if (urlEnv && ['dev', 'stg', 'pre'].includes(urlEnv)) {
    loaclEnv = urlEnv;
  }
}
// 存一份到 sesstionStorage 里
if (loaclEnv && typeof loaclEnv === 'string') {
  sessionStorage.setItem('env', loaclEnv);
}
loaclEnv = sessionStorage.getItem('env') as I.Env;

// 项目使用到的环境
const ENV = loaclEnv as I.Env;

// 开发配置的env变量
export { ENV };
